<template>
<nav id="sidebar">
  <div id="dismiss">
    <i class="fas fa-arrow-left"></i>
  </div>

  <div class="sidebar-header">
    <h3>Batam Teknik Medan</h3>
  </div>

  <ul class="list-unstyled components">
    <li v-for="(nav, navIndex) in navData" :key="navIndex">
      <div v-if="nav.child.length !== 0">
        <li>
          <a :href="`#${nav.id}SubMenu`" data-toggle="collapse" aria-expanded="false">{{nav.title}}</a>
          <ul class="collapse list-unstyled" :id="`${nav.id}SubMenu`">
            <li>
              <router-link v-for="(child, index) in nav.child" :key="index" :to="{ name: child.url }"><i :class="child.icon"></i> {{ child.title }}</router-link>
            </li>
          </ul>
        </li>
      </div>
    </li>
     <li >
      <router-link to="" class="collapse list-unstyled" @click.native="logout">Logout</router-link>
    </li>
  </ul>
</nav>
</template>

<script>
import { mapActions } from 'vuex'
import api from '../services/api'

export default {
  data() {
    return {
      fullName: localStorage.getItem('btm_loggedUser'),
      navData: []
    }
  },
  async created() {
    const accessApi = api('access-permission-list')
    const accessMenu = await accessApi.get();
    this.navData = accessMenu
  },
  mounted() {
    $(document).ready(function () {
      $("#sidebar").mCustomScrollbar({
        theme: "minimal"
      });

      $('#dismiss, .overlay').on('click', function () {
        $('#sidebar').removeClass('active');
        $('.overlay').removeClass('active');
      });

      $('#sidebarCollapse').on('click', function () {
        $('#sidebar').addClass('active');
        $('.overlay').addClass('active');
        $('.collapse.in').toggleClass('in');
        $('a[aria-expanded=true]').attr('aria-expanded', 'false');
      });
    });
  },
  methods: {
    ...mapActions(['appLogout']),
    renderActiveLink(routeName) {
      return (this.$route.name === routeName) ? 'active' : ''
    },
    logout() {
      this.appLogout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>